const faq = (() => {
  const faqToggles = ".js-faqToggle";
  const faqCollapsible = ".js-collapseFaq"

  function onToggleClick(e) {
    e.preventDefault();
    let toggles = document.querySelectorAll(faqToggles)

    toggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.parentNode.classList.contains('active')
        ? el.parentNode.classList.remove('active')
        : el.parentNode.classList.add('active')
      }
    })
  }

  function onCollapsedClick(e) {
    e.preventDefault();
    let toggles = document.querySelectorAll(faqCollapsible)

    toggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.parentNode.classList.contains('active')
        ? el.parentNode.classList.remove('active')
        : el.parentNode.classList.add('active')
      }
    })
  }

  function bind() {

    const faqTogs = document.querySelectorAll(faqToggles);
      Array.prototype.forEach.call(faqTogs, (el) => {
        el.removeEventListener("click", onToggleClick);
        el.addEventListener("click", onToggleClick);
    });

    const collapsedToggles = document.querySelectorAll(faqCollapsible);
      Array.prototype.forEach.call(collapsedToggles, (el) => {
        el.removeEventListener("click", onCollapsedClick);
        el.addEventListener("click", onCollapsedClick);
    });

  }

  function init() {
    bind();
  }

  return {
    init,
  };
})();

export default faq;